export default {
  id: 'ClassDetail',
  code: 'CN',
  text: {
    'Used/Paid': '已消耗/已缴学费',
    'Setup': '未设置',
    'Class Description':'班级简介',
    'Discounted': '折扣',


  }
}



// WEBPACK FOOTER //
// ./src/containers/pages/ClassDetail/locale.js